// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Card_card__oHhc5 {
  position: relative;
  padding: 16px;
  border-radius: 12px;
  break-inside: avoid-column;
  background: #f5f5ff;
  color: #00007a;
}
.Card_card__oHhc5.Card_warning__jW4S4 {
  background: #FEF9F0;
}
.Card_card__oHhc5.Card_warning__jW4S4 .Card_title-text__aB3K0, .Card_card__oHhc5.Card_warning__jW4S4 .Card_content__KF0Wx {
  color: #B94402 !important;
}
.Card_card__oHhc5.Card_warning__jW4S4:hover {
  outline: 1px solid #fbd298 !important;
}
.Card_card__oHhc5.Card_refused__VbueK {
  background: #FDF1ED;
}
.Card_card__oHhc5.Card_refused__VbueK .Card_title-text__aB3K0 {
  color: #7B1028;
}
.Card_card__oHhc5.Card_clickable__GEn2F {
  cursor: pointer;
}
.Card_card__oHhc5.Card_clickable__GEn2F:hover {
  outline: 1px solid #4343ff;
}
.Card_card__oHhc5.Card_centered__JaPbL {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.Card_card__oHhc5.Card_disabled__szMC6::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 12px;
  background: #f5f5ff;
  opacity: 0.85;
}
.Card_card__oHhc5.Card_inactive__TVaZk {
  background: #f9f9fa;
  opacity: 50%;
}
.Card_card__oHhc5.Card_inactive__TVaZk .Card_content__KF0Wx {
  color: #838390;
}
.Card_card__oHhc5.Card_success__EpExL, .Card_card__oHhc5.Card_error__EYU2H, .Card_card__oHhc5.Card_warning__jW4S4 {
  border: none;
}
.Card_card__oHhc5.Card_success__EpExL .Card_title-text__aB3K0, .Card_card__oHhc5.Card_error__EYU2H .Card_title-text__aB3K0, .Card_card__oHhc5.Card_warning__jW4S4 .Card_title-text__aB3K0 {
  color: #00007a;
}
.Card_card__oHhc5.Card_success__EpExL {
  background: #f4fced;
}
.Card_card__oHhc5.Card_warning__jW4S4 {
  background: #fef9f0;
}
.Card_card__oHhc5.Card_error__EYU2H {
  background: #fdf1ed;
}

.Card_top__uj4pJ {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.Card_title__URhiP {
  display: flex;
  align-items: center;
  max-width: calc(100% - 20px);
}
.Card_title__URhiP svg {
  margin-right: 11px;
}

.Card_corner-content__90Fu4 {
  display: flex;
  align-items: flex-start;
  padding-top: 5px;
  cursor: pointer;
}
.Card_corner-content__90Fu4 svg {
  display: block;
}

.Card_title-text__aB3K0 {
  color: #1414ff;
  font-weight: 400;
  font-size: 16px;
  line-height: 28px;
}
.Card_title-text__aB3K0.Card_inactive__TVaZk {
  background: #f9f9fa;
}
.Card_title-text__aB3K0 i {
  font-weight: 300;
  font-size: 12px;
}

.Card_content__KF0Wx {
  margin-top: 8px;
  color: #00007a;
  font-weight: 500;
  font-size: 16px;
  line-height: 28px;
}
.Card_content__KF0Wx.Card_hidden__QND3c {
  display: none;
}

@media screen and (max-width: 600px) {
  .Card_card__oHhc5 {
    position: relative;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/common/Card/Card.module.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAGA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,0BAAA;EACA,mBCRS;EDST,cCFS;ADMX;AAFE;EACE,mBAAA;AAIJ;AAFI;EACE,yBAAA;AAIN;AADI;EACE,qCAAA;AAGN;AACE;EACE,mBAAA;AACJ;AACI;EACE,cAAA;AACN;AAGE;EACE,eAAA;AADJ;AAGI;EACE,0BAAA;AADN;AAKE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAHJ;AAOI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBCvDK;EDwDL,aAAA;AALN;AASE;EACE,mBC/CO;EDgDP,YAAA;AAPJ;AASI;EACE,cCjDK;AD0CX;AAWE;EAGE,YAAA;AAXJ;AAaI;EACE,cCpEK;ADyDX;AAeE;EACE,mBC9DO;ADiDX;AAgBE;EACE,mBC9DS;ADgDb;AAiBE;EACE,mBC7DM;AD8CV;;AAmBA;EACE,aAAA;EACA,8BAAA;EACA,eAAA;AAhBF;;AAmBA;EACE,aAAA;EACA,mBAAA;EACA,4BAAA;AAhBF;AAkBE;EACE,kBAAA;AAhBJ;;AAoBA;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;AAjBF;AAmBE;EACE,cAAA;AAjBJ;;AAqBA;EACE,cCpHS;EDqHT,gBAAA;EACA,eAAA;EACA,iBAAA;AAlBF;AAoBE;EACE,mBChHO;AD8FX;AAqBE;EACE,gBAAA;EACA,eAAA;AAnBJ;;AAuBA;EACE,eAAA;EACA,cClIS;EDmIT,gBAAA;EACA,eAAA;EACA,iBAAA;AApBF;AAsBE;EACE,aAAA;AApBJ;;AAwBA;EACE;IACE,kBAAA;EArBF;AACF","sourcesContent":["@use 'styles/colors.scss';\n@use 'styles/sizes.scss';\n\n.card {\n  position: relative;\n  padding: 16px;\n  border-radius: 12px;\n  break-inside: avoid-column;\n  background: colors.$primary1;\n  color: colors.$primary8;\n\n  &.warning{\n    background: #FEF9F0;\n\n    .title-text, .content {\n      color: #B94402!important;\n    }\n\n    &:hover{\n      outline: 1px solid colors.$attention3!important;\n    }\n  }\n\n  &.refused{\n    background: #FDF1ED;\n\n    .title-text {\n      color: #7B1028;\n    }\n  }\n\n  &.clickable {\n    cursor: pointer;\n\n    &:hover {\n      outline: 1px solid colors.$primary4;\n    }\n  }\n\n  &.centered {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n  }\n\n  &.disabled {\n    &::after {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      border-radius: 12px;\n      background: colors.$primary1;\n      opacity: 0.85;\n    }\n  }\n\n  &.inactive {\n    background: colors.$neutral2;\n    opacity: 50%;\n\n    .content {\n      color: colors.$neutral8;\n    }\n  }\n\n  &.success,\n  &.error,\n  &.warning {\n    border: none;\n\n    .title-text {\n      color: colors.$primary8;\n    }\n  }\n\n  &.success {\n    background: colors.$success1;\n  }\n\n  &.warning {\n    background: colors.$attention1;\n  }\n\n  &.error {\n    background: colors.$danger1;\n  }\n}\n\n.top {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n}\n\n.title {\n  display: flex;\n  align-items: center;\n  max-width: calc(100% - 20px);\n\n  svg {\n    margin-right: 11px;\n  }\n}\n\n.corner-content {\n  display: flex;\n  align-items: flex-start;\n  padding-top: 5px;\n  cursor: pointer;\n\n  svg{\n    display: block;\n  }\n}\n\n.title-text {\n  color: colors.$primary5;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 28px;\n\n  &.inactive {\n    background: colors.$neutral2;\n  }\n\n  i{\n    font-weight: 300;\n    font-size: 12px;\n  }\n}\n\n.content {\n  margin-top: 8px;\n  color: colors.$primary8;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 28px;\n\n  &.hidden{\n    display: none;\n  }\n}\n\n@media screen and (max-width: sizes.$breakpoint-sm) {\n  .card {\n    position: relative;\n  }\n}\n","$primary1: #f5f5ff;\n$primary2: #d8d8ff;\n$primary3: #8686ff;\n$primary4: #4343ff;\n$primary5: #1414ff;\n$primary6: #0000c9;\n$primary7: #000093;\n$primary8: #00007a;\n$primary9: #000054;\n$primary10: #00003a;\n$primary11: #000078;\n$blueLogo: #000093;\n\n$neutral1: #fcfcfd;\n$neutral2: #f9f9fa;\n$neutral4: #e0e0e3;\n$neutral8: #838390;\n\n$success1: #f4fced;\n$success5: #58b441;\n$success6: #126f0e;\n\n$attention1: #fef9f0;\n$attention3: #fbd298;\n$attention5: #e78d3d;\n$attention7: #b94402;\n\n$danger1: #fdf1ed;\n$danger2: #f9d9cf;\n$danger3: #f4ada1;\n$danger5: #bd454a;\n$danger6: #911727;\n$danger7: #7c1028;\n\n\n$colabelNeutralLight: #F9F9FA;\n$colabelNeutralMid: #C3C3C9;\n$colabelNeutralDark: #121217;\n\n:export {\n    colabelNeutralLight: $colabelNeutralLight;\n    colabelNeutralMid: $colabelNeutralMid;\n    colabelNeutralDark: $colabelNeutralDark;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`,
	"card": `Card_card__oHhc5`,
	"warning": `Card_warning__jW4S4`,
	"title-text": `Card_title-text__aB3K0`,
	"content": `Card_content__KF0Wx`,
	"refused": `Card_refused__VbueK`,
	"clickable": `Card_clickable__GEn2F`,
	"centered": `Card_centered__JaPbL`,
	"disabled": `Card_disabled__szMC6`,
	"inactive": `Card_inactive__TVaZk`,
	"success": `Card_success__EpExL`,
	"error": `Card_error__EYU2H`,
	"top": `Card_top__uj4pJ`,
	"title": `Card_title__URhiP`,
	"corner-content": `Card_corner-content__90Fu4`,
	"hidden": `Card_hidden__QND3c`
};
export default ___CSS_LOADER_EXPORT___;
